import { getPropVal, isDate } from '@finegold/base';
import { SortDir } from '../meta/basetype';
import { NOTNULLVALUE, NULLVALUE, orderByToSorts, PageData, QueryColumn, QueryParams, QuerySort, RestQuery } from './restquery';

export class LocalQuery {
    constructor(private query: RestQuery) { }

    applyable() {
        let q = this.query
        //è®¡æ¬å°ä¸æ¯æ
        if (q.aggregate && q.aggregate.length > 0) {
            return false;
        }

        //å¨ææ£ç´¢ï¼æ¬å°ä¸æ¯æ
        let params = q.search
        for (const key in params) {
            let val = params[key];
            if (val == null || val == undefined) continue;
            if (typeof (val) == 'string' && val.startsWith('**')) return false;
        }

        //å°è®¡æ¬å°ä¸æ¯æ
        if (q.columns) {
            if (typeof (q.columns) != 'string') {
                let cols: QueryColumn[] = q.columns;
                if (cols.length > 0 && cols.find(it => it.agg)) {
                    return false;
                }
            }
        }

        return true;
    }

    applySort(datas: Object[]) {
        let sorts = this.query.sort || [];
        sorts = [...orderByToSorts(this.query.orderBy), ...sorts]
        return sortList(datas, sorts)
    }

    applyFilter(datas: Object[]) {
        return filterList(datas, this.query.search)
    }

    applyQuery(datas: Object[]): PageData<any> {
        return queryList(datas, this.query)
    }

    static localApplyable(query: RestQuery) {
        return new LocalQuery(query).applyable();
    }
    static localApplyQuery(datas: Object[], query: RestQuery) {
        return new LocalQuery(query).applyQuery(datas)
    }
}

export class LocalDataset {
    get datas() {
        return this.list;
    }

    constructor(private list: Object[]) { }

    sort(sort: string): this;
    sort(sort: QuerySort[]): this;
    sort(sort: string | QuerySort[]): this {
        if (sort) {
            let sorts: QuerySort[] = typeof (sort) == 'string'
                ? orderByToSorts(sort) : sort;

            this.list = sortList(this.list, sorts)
        }
        return this;
    }

    filter(filter: QueryParams) {
        this.list = filterList(this.list, filter)
        return this;
    }

    slice(from: number, count: number) {
        this.list = this.list.slice(from, from + count);
        return this;
    }

    query(query: RestQuery) {
        return queryList(this.list, query);
    }
}

export function calcFilter(obj: Object, pn: string, pv: any) {
    //å¤çç¹æ®å±æ§
    if (pn.startsWith("*(") && pn.endsWith(")")) {
        let props = pn.substring(2, pn.length - 1).split(',').filter(it => !!it)
        for (let prop of props) {
            if (calcFilter(obj, prop, '*' + pv + '*')) {
                return true;
            }
        }
        return false;
    } else if (pn.startsWith('~') && pn.endsWith('~')) {
        let props = pn.substring(1, pn.length - 1).split(',').filter(it => !!it)
        for (let prop of props) {
            if (calcFilter(obj, prop, pv)) {
                return true;
            }
        }
        return false;
    } else if (pn.startsWith('(') && pn.endsWith(')')) {
        let props = pn.substring(1, pn.length - 1).split(',').filter(it => !!it)
        for (let prop of props) {
            if (!calcFilter(obj, prop, pv)) {
                return false;
            }
        }
        return true;
    }

    //å¤çæ¡ä»¶å¼
    if (Array.isArray(pv)) {
        for (let v of pv) {
            //å¿½ç¥ç©ºå¼
            if (v == null || v == undefined || (typeof (v) == 'string' && v.trim() == '')) {
                continue;
            }
            if (calcFilter(obj, pn, v)) {
                return true;
            }
        }
        return false;
    } else if (typeof (pv) == 'object') {
        for (let tmp in pv) {
            let v = pv[tmp];
            //å¿½ç¥ç©ºå¼
            if (v == null || v == undefined || (typeof (v) == 'string' && v.trim() == '')) {
                continue;
            }

            if (!calcFilter(obj, tmp, v)) {
                return false;
            }
        }
        return true;
    } else if (typeof (pv) == 'string' && pv.includes(' ')) {
        let tmps = pv.split(' ').filter(it => !!it)
        for (let tmp of tmps) {
            if (!calcFilter(obj, pn, tmp)) {
                return false;
            }
        }
        return true;
    } else {
        let val = getPropVal(obj, pn)

        //ç¹æ®å¤çNULLå¼ï¼ååå°é»è¾ä¸è´
        if (pv == NULLVALUE) {
            return val == null || val == undefined
        } else if (pv == NOTNULLVALUE) {
            return val != null && val != undefined
        }
        //NULLåä¸ä»»ä½æ¡ä»¶é½ä¸ºFALSE
        if (val == null || val == undefined) {
            return false;
        }

        if (typeof (pv) == 'string') {
            if (pv.startsWith('*') && pv.endsWith('*')) {
                return (val + '').includes(pv.substring(1, pv.length - 1))
            } else if (pv.startsWith('*')) {
                return (val + '').endsWith(pv.substring(1))
            } else if (pv.endsWith('*')) {
                return (val + '').startsWith(pv.substring(0, pv.length - 1))
            } else if ((pv.startsWith("(") || pv.startsWith("<"))
                && (pv.endsWith(")") || pv.endsWith(">"))) {
                let tmps = pv.substring(1, pv.length - 1).split(",").filter(it => !!it);
                let v1 = toType(tmps[0], val)
                let v2 = tmps.length > 1 ? toType(tmps[1], val) : null;
                if (v1 != null) {
                    if (pv.startsWith("(") ? val < v1 : val <= v1) return false;
                }
                if (v2 != null) {
                    if (pv.endsWith(")") ? val > v2 : val >= v2) return false;
                }
                return true;
            } else if (pv.startsWith("[") && pv.endsWith("]")) {
                let tmps = pv.substring(1, pv.length - 1).split(",").filter(it => !!it);
                for (let tmp of tmps) {
                    if (val == toType(tmp, val)) return true;
                }
                return false;
            } else if (pv.startsWith("<>") || pv.startsWith("!=")) {
                let tmps = pv.substring(2).split(",").filter(it => !!it)
                for (let tmp of tmps) {
                    if (val == toType(tmp, val)) return false;
                }
                return true;
            } else if (pv.startsWith(">>")) {
                let v = toType(pv.substring(2), val);
                return val > v
            } else if (pv.startsWith(">=")) {
                let v = toType(pv.substring(2), val);
                return val >= v
            } else if (pv.startsWith("<<")) {
                let v = toType(pv.substring(2), val);
                return val < v
            } else if (pv.startsWith("<=")) {
                let v = toType(pv.substring(2), val);
                return val <= v
            } else {
                return toType(pv, val) == val;
            }
        } else {
            return toType(pv, val) == val;
        }
    }
}

export function compareObjectByProp(a: Object, b: Object, propName: string, dir: SortDir): number {
    let v1 = getPropVal(a, propName), v2 = getPropVal(b, propName)
    let r = 0;

    if (v1 == null && v2 == null) {
        r = 0;
    } else if (v1 == null) {
        r = -1;
    } else if (v2 == null) {
        r = 1
    } else {
        if (typeof (v1) == 'string') {
            r = v1.localeCompare(v2);
        } else if (typeof (v1) == 'number') {
            r = v1 - v2;
        } else if (isDate(v1)) {
            r = (v1 as Date).getTime() - (v2 as Date).getTime()
        }
    }

    return dir != 'desc' ? r : -r;
}

export function filterList(datas: Object[], filter: QueryParams) {
    return filter
        ? datas.filter(it => calcFilter(it, 'foo', filter))
        : datas;
}

export function sortList(datas: Object[], sorts: QuerySort[]) {
    return sorts
        ? datas.sort((a, b) => {
            let r = 0
            for (let sort of sorts) {
                r = compareObjectByProp(a, b, sort.field, sort.dir);
                if (r != 0) return r;
            }
            return r;
        })
        : datas;
}

export function queryList(datas: Object[], query: RestQuery) {
    let q = query;
    let page: PageData<Object> = {
        first: query.first,
        rows: query.rows,
        datas: [],
        total: 0
    }

    let list = datas;
    //å¤çæ¡ä»¶
    list = filterList(list, q.search)

    //å¤çæåº
    let sorts = q.sort || [];
    sorts = [...orderByToSorts(q.orderBy), ...sorts]
    list = sortList(list, sorts)

    page.total = list.length;

    //å¤çåé¡µ
    if (q.limit > 0) {
        list = list.slice(0, q.limit)
    }
    if (q.rows > 0) {
        list = list.slice(q.first, q.rows + q.first)
    }

    //åºåè¿åå
    if (q.columns) {
        let cols: QueryColumn[] = []
        if (typeof (q.columns) == 'string') {
            cols = q.columns.split('[,;]').map(it => ({
                field: it.replace('.', '_'),
                propName: it
            } as QueryColumn))
        } else {
            cols = q.columns;
        }
        if (cols.length > 0) {
            list = list.map(it => {
                let ret = {};
                for (let col of cols) {
                    ret[col.field] = getPropVal(it, col.propName)
                }
                return ret;
            })
        }
    }

    page.datas = list;
    return page;
}

function toType(from: string, sample: any) {
    if (from == null || from == '') {
        return null;
    }
    switch (typeof (sample)) {
        case 'number':
            return parseFloat(from)
        case 'boolean':
            return !from && from != '0' && from != 'false'
        case 'bigint':
            return parseInt(from)
    }
    if (isDate(sample)) {
        return new Date(from)
    }
    return from;
}